module.exports = __webpack_public_path__ + "static/media/i41img2.b8815b25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/i41img2.jpg
// module id = 686
// module chunks = 0